import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { createNullOption } from '@cas/components/inputs/dropdown-items/utils';
import {
  GeofenceSpeedLimitModel,
  useListGeofenceSpeedLimitsQuery,
} from '@casops/store/apis/geofenceSpeedLimitsApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useSpeedOptions = (): DropdownItemProps<number | null>[] => {
  const { t } = useTranslation();

  const { data: speedLimits } = useListGeofenceSpeedLimitsQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  return useMemo<DropdownItemProps<number | null>[]>(() => {
    const nullOption = createNullOption(t);

    if (typeof speedLimits !== 'undefined') {
      const numberOptions: DropdownItemProps<number>[] = speedLimits.map(
        ({ id, speed }: GeofenceSpeedLimitModel) => ({
          key: id.toString(),
          value: id,
          stringValue: speed.toString(),
          label: speed.toString(),
        }),
      );

      return [nullOption, ...numberOptions];
    }

    return [nullOption];
  }, [t, speedLimits]);
};

export default useSpeedOptions;
